<div class="d-flex align-items-center justify-content-between startup-profile-header" *ngIf="profiles.length > 1">
  <div class="d-flex align-items-center gap-4">

    <div class="d-flex  align-items-center flex-wrap">
      <label class="me-2">{{ 'PANEL.STARTUP_HEADER.SELECT_STARTUP' | translate }}</label>
      <div class="d-flex align-items-center">
        <p-dropdown [options]="profiles" [(ngModel)]="profile" optionLabel="title" optionValue="id"
          (ngModelChange)="onChange()" class="me-2" [style]="{'min-width':'200px'}">
        </p-dropdown>
        <span pTooltip="{{ 'PANEL.STARTUP_HEADER.TOOLTIP' | translate }}">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
              fill="#6989d5" fill-opacity="0.2" stroke="#6989d5" />
            <path
              d="M12.25 13C12.25 13.1339 12.1339 13.25 12 13.25C11.8661 13.25 11.75 13.1339 11.75 13V8C11.75 7.86614 11.8661 7.75 12 7.75C12.1339 7.75 12.25 7.86614 12.25 8V13Z"
              fill="#6989d5" fill-opacity="0.2" stroke="#6989d5" />
            <path
              d="M11.5467 16.2005L11.5469 16.2004L11.5415 16.1877C11.5128 16.1188 11.5 16.0542 11.5 16C11.5 15.9459 11.5128 15.8812 11.5415 15.8123C11.566 15.7536 11.5996 15.6978 11.6444 15.6444C11.6978 15.5996 11.7536 15.566 11.8123 15.5415C11.9292 15.4928 12.0708 15.4928 12.1877 15.5415C12.2464 15.566 12.3022 15.5996 12.3556 15.6444C12.4004 15.6978 12.434 15.7536 12.4585 15.8123C12.4872 15.8812 12.5 15.9459 12.5 16C12.5 16.0542 12.4872 16.1188 12.4585 16.1877L12.4583 16.1876L12.4533 16.2005C12.4336 16.2517 12.4069 16.2962 12.3565 16.3549C12.3028 16.4001 12.2467 16.4339 12.1877 16.4585C12.1188 16.4872 12.0541 16.5 12 16.5C11.9459 16.5 11.8812 16.4872 11.8123 16.4585C11.7533 16.4339 11.6972 16.4001 11.6435 16.3549C11.5931 16.2962 11.5664 16.2517 11.5467 16.2005Z"
              fill="#6989d5" fill-opacity="0.2" stroke="#6989d5" />
          </svg>
        </span>

      </div>
    </div>

  </div>


</div>